import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import TileHeader from '../../components/TileHeader/TileHeader'
// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import { Search, Button } from 'carbon-components-react';
import CTGListGrid from './CTGListGrid';

const CTGListContent = ({
  ctgList,
  setTriggerExport,
  triggerExport,
  // onDeleteClicked,
  // onSyncClicked,
  // onExportClicked,
  refresh,
  setRefresh,
}) => {
  const [search, setSearch] = useState("");
  const [searchGrid, setSearchGrid] = useState("");
  const [sort, setSort] = useState("")
  //Waits for a second after last user input on search
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search);
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search]);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
          title="All CTG Studies"
          size="lg"
        />
        <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => {
                  setSearch(e.target.value)

                }}
                placeHolderText="Search using any data value"
              />
            </div>
          </ActionBar>

    
      <StudyContent>
          <CTGListGrid
            search={searchGrid}
            studyList={ctgList} 
            setTriggerExport={setTriggerExport}
            triggerExport={triggerExport}
            // onDeleteClicked={onDeleteClicked}
            refresh={refresh}
            setRefresh={setRefresh}
            sort={sort}
            setSort={setSort}
            />
      </StudyContent>
      </ContentContainer>
    </Container>
  );
};

export default CTGListContent;


const StudyContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #fff;
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  // background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonPadding = styled.div`
  display: flex;
  gap: 8px;
  background-color: #fff;

`

const addStudyBtnStyle = {
  padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px"
};

const ContentHeader = styled.div`
  flex: 0 1 auto;
`